<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

const animationDuration = 6000

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    /** 传入后覆盖默认示例：{ categories: string[], values: number[] } */
    chartSource: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      chart: null,
      weeks: [
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
        ]
    }
  },
  created(){
    this.getWeeks()
  },
  watch: {
    chartSource: {
      deep: true,
      handler() {
        if (this.chart) {
          this.initChart()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {  
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(this.$el, 'macarons')
      }
      const src = this.chartSource
      if (src && Array.isArray(src.categories) && Array.isArray(src.values) && src.categories.length) {
        this.chart.setOption({
          tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
          grid: { top: 10, left: '2%', right: '2%', bottom: '3%', containLabel: true },
          xAxis: [{ type: 'category', data: src.categories, axisTick: { alignWithLabel: true }, axisLabel: { rotate: 28 } }],
          yAxis: [{ type: 'value', axisTick: { show: false } }],
          series: [{
            name: src.seriesName || '销售额',
            type: 'bar',
            barWidth: '55%',
            data: src.values,
            animationDuration
          }]
        }, true)
        return
      }
      this.chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: 10,
          left: '2%',
          right: '2%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: this.weeks,
          axisTick: {
            alignWithLabel: true
          }
        }],
        yAxis: [{
          type: 'value',
          axisTick: {
            show: false
          }
        }],
        series: [{
          name: '男性',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: [79, 52, 200, 334, 390, 330, 220],
          animationDuration
        }, {
          name: '女性',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: [80, 52, 200, 334, 390, 330, 220],
          animationDuration
        }, {
          name: '男女比率',
          type: 'bar',
          stack: 'vistors',
          barWidth: '60%',
          data: [30, 52, 200, 334, 390, 330, 220],
          animationDuration
        }]
      }, true)
    },
    getWeeks () {  
        let date = new Date()  
        let wk = date.getDay()
        let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
        let before = []
        let after = []
        for (let index = 0; index < weeks.length; index++) {
          if (wk < index){
            before.push(weeks[index])
          }
          if (wk > index){
            after.push(weeks[index])
          }
        }
        this.weeks = before.concat(after)
        this.weeks.push(weeks[wk])
    }
  }
}
</script>
